import { ESortDirection } from 'ui/EasTable/types';
import { TOrderBy } from 'redux/types';

export const REPORTS_SLICE_NAME = 'reports';

/** The Reporting Center table is not sortable by the user, the order is always the same. */
export const AVAILABLE_REPORTS_ORDER_BY: TOrderBy[] = [
	{ fieldName: 'createdAt', direction: ESortDirection.DESC },
	{ fieldName: 'reportTypeName', direction: ESortDirection.ASC },
];
